import { render, staticRenderFns } from "./classifyList.vue?vue&type=template&id=05d07d44&scoped=true&"
import script from "./classifyList.vue?vue&type=script&lang=js&"
export * from "./classifyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d07d44",
  null
  
)

export default component.exports